
export function getProtooUrl({ roomId, peerId }) {
  let url = `wss://stream.test.viliyo.com/protoo/?roomId=${roomId}&peerId=${peerId}` // for alpha
  return url;
}

// export function getProtooUrl({ roomId, peerId }) {
//   let url = `wss://openvidustream.akashkumarshukla.in/protoo/?roomId=${roomId}&peerId=${peerId}` // for alpha
//   return url;
// }
